'use strict'

// CJS entry for packages that do require('moment'). Must not import src/utils/moment.js (circular).
module.exports = require('moment/moment.js')
